// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/offcanvas.js
import BackdroppedComponent from "./backdropped-component"

export default class Offcanvas extends BackdroppedComponent {
  static componentName = "offcanvas"
  static defaults = { backdrop: true, keyboard: true, scroll: false }

  constructor(element, config = {}) {
    super(element, config)
    this.listen(element, "keydown", (event) => {
      if (event.key !== "Escape" || !this.shown) return
      if (this.config.keyboard) this.hide()
      else this.emit("hidePrevented")
    })
  }

  show(relatedTarget = null) {
    if (this.shown || this.transitioning || this.emit("show", { relatedTarget }, { cancelable: true }).defaultPrevented)
      return
    this.shown = true
    this.transitioning = true
    this.previouslyFocused = relatedTarget || document.activeElement
    if (!this.config.scroll) this.lockScroll()
    this.createBackdrop("offcanvas-backdrop")
    this.element.setAttribute("aria-modal", "true")
    this.element.setAttribute("role", "dialog")
    this.element.classList.add("showing")
    this.afterTransition(this.element, () => {
      this.element.classList.remove("showing")
      this.element.classList.add("show")
      this.transitioning = false
      if (!this.config.scroll || this.config.backdrop) this.activateFocusTrap()
      this.emit("shown", { relatedTarget })
      if (this.pendingHide) {
        this.pendingHide = false
        this.hide()
      }
    })
  }

  hide() {
    if (this.shown && this.transitioning) {
      this.pendingHide = true
      return
    }
    if (!this.shown || this.transitioning || this.emit("hide", {}, { cancelable: true }).defaultPrevented) return
    this.shown = false
    this.transitioning = true
    this.releaseFocus(false)
    this.element.classList.add("hiding")
    this.afterTransition(this.element, () => {
      this.element.classList.remove("show", "hiding")
      this.element.removeAttribute("aria-modal")
      this.element.removeAttribute("role")
      this.removeBackdrop()
      this.unlockScroll()
      this.transitioning = false
      this.releaseFocus()
      this.emit("hidden")
    })
  }

  toggle(relatedTarget = null) {
    this.shown ? this.hide() : this.show(relatedTarget)
  }
}
